// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1{font-size:17px;font-weight:900;line-height:18px;text-transform:uppercase;margin:30px 0 20px}.landing{padding-bottom:50px}.landing__breadcrumbs{padding-top:70px}.landing ul li a{color:#000}.landing ul li+li{padding-top:10px}", ""]);
// Exports
module.exports = exports;
